var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDonut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.0798C16.06 5.5198 18.48 7.9398 18.92 10.9998H21.95C21.48 6.2798 17.72 2.5198 13 2.0498V5.0798V5.0798ZM18.92 12.9998C18.48 16.0598 16.06 18.4798 13 18.9198V21.9498C17.72 21.4798 21.48 17.7198 21.95 12.9998H18.92V12.9998ZM11 18.9198C7.61 18.4298 5 15.5198 5 11.9998C5 8.4798 7.61 5.5698 11 5.0798V2.0498C5.95 2.5498 2 6.8098 2 11.9998C2 17.1898 5.95 21.4498 11 21.9498V18.9198V18.9198Z",
    fill: "#031C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonut);
export default __webpack_public_path__ + "static/media/donut.3da77011ae8ddd56369592fcf8b795ef.svg";
export { ForwardRef as ReactComponent };